export function mergeFilters(srcFilters, destFilters) {
  const mergedFieldIds = [];
  let filters = [];

  if(srcFilters.length > 0) {
    srcFilters.forEach(filter => {
      filters.push(filter);
    });
  } else {
    filters = destFilters;
  }

  if(filters.length > 0) {
    
    filters.forEach((filter, index) => {
      for(let i = 0; i < destFilters.length; i++) {
          if(filter.field_id == destFilters[i].field_id) {
            mergedFieldIds.push(filter.field_id);
            filters[index] = gudhub.mergeObjects(destFilters[i], filter);
          }
      }
    });

    for(let k = 0; k < destFilters.length; k++) {
      if(!mergedFieldIds.includes(destFilters[k].field_id)) {
        filters.push(destFilters[k]);
      }
    }

  }
  return filters;
}